import { DialogRef } from '@angular/cdk/dialog';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-save-close',
  templateUrl: './dialog-save-close.component.html',
  styleUrls: ['./dialog-save-close.component.sass'],
})
export class DialogSaveCloseComponent implements OnInit {
  @Input()
  closeText: string;
  @Input()
  closeOnSave: boolean = true;
  @Input()
  saveText: string;
  @Input()
  hasClose: boolean = true;
  @Output()
  onSave: EventEmitter<any> = new EventEmitter();

  constructor(private dialogRef: MatDialogRef<DialogSaveCloseComponent>) {}

  ngOnInit(): void {}

  public save() {
    if (this.closeOnSave) this.dialogRef.close();
    this.onSave.emit();
  }
}
